import Typography, { type TypographyProps } from "@mui/material/Typography";

/** A standard body paragraph — the default prose role on a page. */
export function Body(props: TypographyProps) {
  return <Typography variant="body1" {...props} />;
}
